"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const dateToEpochSeconds_1 = __importDefault(require("./dateToEpochSeconds"));
function timeFinishedIsInTheFuture(lastStudied, timeFinished) {
    if (!lastStudied) {
        return true;
    }
    if (!timeFinished) {
        return false;
    }
    const newLastStudied = (0, dateToEpochSeconds_1.default)(new Date(timeFinished));
    return newLastStudied > lastStudied;
}
exports.default = timeFinishedIsInTheFuture;
